/** Filters in the address bar, for every admin data screen.
 *
 * A filter that lives in the URL can be linked to — the Dashboard's "held"
 * figure opens the Uploads screen already narrowed to held rows, a support
 * reply can point at one account's sessions — and it survives a reload. The
 * Issues screen set the pattern; this is the same helper, written once so
 * every data screen deletes an emptied key the same way instead of leaving
 * `?status=` behind.
 */

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export type ParamEntries = Record<string, string | null | undefined>;

export type SetParams = (entries: ParamEntries, replace?: boolean) => void;

export function useQueryParams(): [URLSearchParams, SetParams] {
  const [search, setSearch] = useSearchParams();
  const setParam = useCallback<SetParams>(
    (entries, replace = false) => {
      setSearch(
        (previous) => {
          const next = new URLSearchParams(previous);
          for (const [key, value] of Object.entries(entries)) {
            if (value === null || value === undefined || value === '') next.delete(key);
            else next.set(key, value);
          }
          return next;
        },
        { replace },
      );
    },
    [setSearch],
  );
  return [search, setParam];
}

export default useQueryParams;
